import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07bee738"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-login c-secondary" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-left" }, null, -1))
const _hoisted_3 = { class: "types" }
const _hoisted_4 = { class: "input getCode" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "input" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "input" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "submit" }
const _hoisted_11 = { class: "types" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "tip" }
const _hoisted_14 = { class: "qr" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "input" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "input" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "links c-thirdary" }
const _hoisted_21 = { class: "submit" }
const _hoisted_22 = { class: "protocols" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("， ")

import api from '@/api/userApi';
import { showDialog } from '@/store';
import devices from '@/store/device';
import i18, { State as I18State } from '@/store/i18';
import user from '@/store/user';
import QRCode from 'qrcode';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useStore } from 'vuex';
type UserEvent = "register" | "mobilelogin";

export default /*#__PURE__*/_defineComponent({
  props: {
    options: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'close'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    options: {
        resolve: Function,
        reject: Function
    },
}

const store = useStore()
const i18Data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18Data.value.texts[i18Data.value.lang.list[i18Data.value.lang.now]].login)


const canvas = ref()
const state = reactive({
    visible: false,
    loginType: 'qrcode',
    qrcode: '',
    agreement: true,
    username: '',
    password: '',
    again: '',
    account: '',
})
const event = ref<UserEvent>('mobilelogin')


onMounted(async () => {
    onChangeLogin('qrcode')
})

watch(event, () => {
    state.account = ''
    state.username = ''
    state.password = ''
    state.again = ''
})

async function onLogin() {
    if (!state.agreement) {
        return;
    }
    if (!state.account) {
        devices.toast(store, lang.value.account_placeholder)
        return
    }
    if (!state.password) {
        devices.toast(store, lang.value.password_placeholder)
        return
    }
    try {
        let userinfo = await api.loginByPassword(state.account, state.password)
        user.login(store, userinfo);
        props.options.resolve();
        emits('close');
    } catch (e) {
        devices.toast(store, lang.value.login_error)
    }
}

async function onRegister() {
    if (!state.agreement) {
        return;
    }
    if (!state.username) {
        devices.toast(store, lang.value.username_placeholder)
        return
    }
    if (!state.password) {
        devices.toast(store, lang.value.password_placeholder)
        return
    }
    if (!state.again) {
        devices.toast(store, lang.value.again_placeholder)
        return
    }
    if (state.again != state.password) {
        devices.toast(store, lang.value.password_again_wrong)
        return
    }
    try {
        let userinfo = await api.register(state.username, state.password);
        user.login(store, userinfo);
        props.options.resolve();
        devices.toast(store, lang.value.register_success)
        emits('close');
    } catch (e: any) {
        devices.toast(store, e.message)
    }
}

function onCancel() {
    props.options.reject(new Event('cancel login'))
    emits('close')
}

function onChangeLogin(value: string) {
    state.loginType = value
    state.qrcode = ''
    if (value == 'qrcode') {
        loadQrcode()
    }
}

async function loadQrcode() {
    if (state.loginType != 'qrcode' || state.qrcode) {
        return
    }
    let { ticket, check_url } = await api.getLoginQrcode()
    state.qrcode = ticket
    //@ts-ignore
    QRCode.toCanvas(canvas.value, ticket, {
        width: 200,
        height: 200
    }, function (error: any) {
        if (error) console.error(error)
    })

    try {
        let r = await api.get(check_url)
        let userinfo: UserInfo = {
            "id": r.userid,
            "username": r.username,
            "nickname": r.nickname,
            "mobile": '',
            "email": '',
            "avatar": r.headimgurl,
            "token": r.token,
            vemail: 0,
            vpassword: 0,
            vsq: 0,
        }
        user.login(store, userinfo);
        props.options.resolve();
        emits('close');
    } catch (e) {
        console.info('--------refresh')
        state.qrcode = ''
        loadQrcode()
    }
}

function toForget() {
    onCancel()
    showDialog(store, 'forget')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (event.value == 'register')
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (event.value = 'mobilelogin'))
        }, [
          _hoisted_2,
          _createTextVNode(_toDisplayString(_unref(lang).back), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("a", {
      class: "close icon i-guanbi c-thirdary",
      onClick: onCancel
    }),
    (event.value == 'register')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_unref(lang).register), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).username) = $event)),
              placeholder: _unref(lang).username_placeholder
            }, null, 8, _hoisted_5), [
              [_vModelText, _unref(state).username]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).password) = $event)),
              type: "password",
              placeholder: _unref(lang).password_placeholder
            }, null, 8, _hoisted_7), [
              [_vModelText, _unref(state).password]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).again) = $event)),
              type: "password",
              placeholder: _unref(lang).again_placeholder
            }, null, 8, _hoisted_9), [
              [_vModelText, _unref(state).again]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              class: _normalizeClass({ disabled: !_unref(state).agreement }),
              onClick: onRegister
            }, _toDisplayString(_unref(lang).do_register), 3)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              class: _normalizeClass({ on: _unref(state).loginType == 'qrcode' }),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (onChangeLogin('qrcode')))
            }, _toDisplayString(_unref(lang).login_qrcode), 3),
            _createElementVNode("a", {
              class: _normalizeClass({ on: _unref(state).loginType == 'password' }),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (onChangeLogin('password')))
            }, _toDisplayString(_unref(lang).login_password), 3)
          ]),
          (_unref(state).loginType == 'qrcode')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(lang).qrcode_tip), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("canvas", {
                    ref_key: "canvas",
                    ref: canvas
                  }, null, 512)
                ])
              ]))
            : (_unref(state).loginType == 'password')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).account) = $event)),
                      placeholder: _unref(lang).account_placeholder
                    }, null, 8, _hoisted_17), [
                      [_vModelText, _unref(state).account]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).password) = $event)),
                      type: "password",
                      placeholder: _unref(lang).password_placeholder
                    }, null, 8, _hoisted_19), [
                      [_vModelText, _unref(state).password]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
          (_unref(state).loginType != 'qrcode')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("a", {
                    class: "register link",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (event.value = 'register'))
                  }, _toDisplayString(_unref(lang).register), 1),
                  _createElementVNode("a", {
                    class: "forget link",
                    onClick: toForget
                  }, _toDisplayString(_unref(lang).forget) + "？", 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", {
                    class: _normalizeClass({ disabled: !_unref(state).agreement }),
                    onClick: onLogin
                  }, _toDisplayString(_unref(lang).do_login), 3)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 64)),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(state).agreement) = $event))
        }, null, 512), [
          [_vModelCheckbox, _unref(state).agreement]
        ]),
        _createTextVNode(_toDisplayString(_unref(lang).agree), 1)
      ]),
      _createElementVNode("a", {
        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
        href: "/protocols.html",
        target: "_blank"
      }, _toDisplayString(_unref(lang).agree_user), 1),
      _hoisted_23,
      _createElementVNode("a", {
        onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
        href: "/protocols.html",
        target: "_blank"
      }, _toDisplayString(_unref(lang).agree_private), 1)
    ])
  ]))
}
}

})